import { toast } from "react-toastify";

export const toast_notifications = {
  success: (notification) => toast.success(notification),
  error: (notification) => toast.error(notification),
  warning: (notification) => toast.warn(notification),
  info: (notification) => toast.info(notification),
};
